/* =========================================
   CLOVERRUA — HERO SLIDESHOW
   ========================================= */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-cr-hero]').forEach(function (hero) {

    const slides = Array.from(
      hero.querySelectorAll('.cr-hero__slide')
    );

    const dots = Array.from(
      hero.querySelectorAll('.cr-hero__dot')
    );

    const prev = hero.querySelector('[data-cr-prev]');
    const next = hero.querySelector('[data-cr-next]');

    if (slides.length < 2) return;

    let index = 0;
    let timer;


    function show(i) {

      index = (i + slides.length) % slides.length;

      slides.forEach(function (slide, n) {
        slide.classList.toggle(
          'is-active',
          n === index
        );
      });

      dots.forEach(function (dot, n) {
        dot.classList.toggle(
          'is-active',
          n === index
        );
      });

    }


    function start() {

      clearInterval(timer);

      const interval =
        Number(hero.dataset.interval) || 7000;

      timer = setInterval(function () {
        show(index + 1);
      }, interval);

    }


    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
    }


    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
    }


    dots.forEach(function (dot, n) {

      dot.addEventListener('click', function () {
        show(n);
        start();
      });

    });


    show(0);
    start();

  });

});



/* =========================================
   CLOVERRUA — PROVENANCE
   NODE CARDS + RIVER REVEAL + IMAGE LIGHTBOX
   ========================================= */

(function () {

  /*
   * Initialise one provenance section.
   */

  function initProvenance(section) {

    if (!section) return;

    /*
     * Prevent duplicate initialisation.
     * This is particularly important inside
     * the Shopify Theme Editor.
     */

    if (section.dataset.crProvenanceReady === 'true') {
      return;
    }

    section.dataset.crProvenanceReady = 'true';


    /* -----------------------------------------
       NODE / CARD INTERACTION
       ----------------------------------------- */

    const nodes = Array.from(
      section.querySelectorAll('[data-cr-node]')
    );

    const nodeButtons = Array.from(
      section.querySelectorAll('[data-cr-node-button]')
    );


    if (nodes.length) {

      function selectNode(node) {

        nodes.forEach(function (currentNode) {

          const active =
            currentNode === node;

          currentNode.classList.toggle(
            'is-selected',
            active
          );


          const button =
            currentNode.querySelector(
              '[data-cr-node-button]'
            );


          if (button) {

            button.setAttribute(
              'aria-expanded',
              active ? 'true' : 'false'
            );

          }

        });

      }


      nodeButtons.forEach(function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            const node =
              button.closest('[data-cr-node]');

            if (!node) return;

            selectNode(node);

          }
        );

      });

    }



    /* -----------------------------------------
       RIVER DRAW / REVEAL
       ----------------------------------------- */

    function revealRiver() {

      section.classList.add(
        'is-river-drawn'
      );

    }


    if (
      'IntersectionObserver' in window
    ) {

      const observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(function (entry) {

              if (entry.isIntersecting) {

                revealRiver();

                observer.unobserve(
                  entry.target
                );

              }

            });

          },
          {
            threshold: 0.22
          }
        );


      observer.observe(section);

    } else {

      revealRiver();

    }



    /* -----------------------------------------
       PROVENANCE IMAGE LIGHTBOX
       ----------------------------------------- */

    const imageButtons = Array.from(
      section.querySelectorAll(
        '[data-cr-provenance-image]'
      )
    );


    if (!imageButtons.length) {
      return;
    }


    /*
     * Get the existing global lightbox,
     * or create it once.
     */

    let lightbox =
      document.querySelector(
        '[data-cr-provenance-lightbox]'
      );


    if (!lightbox) {

      lightbox =
        document.createElement('div');

      lightbox.className =
        'cr-provenance-lightbox';

      lightbox.setAttribute(
        'data-cr-provenance-lightbox',
        ''
      );

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );


      lightbox.innerHTML = `
        <button
          class="cr-provenance-lightbox__close"
          type="button"
          data-cr-provenance-close
          aria-label="Close image"
        >
          ×
        </button>

        <div class="cr-provenance-lightbox__inner">

          <img
            class="cr-provenance-lightbox__image"
            data-cr-provenance-lightbox-image
            src=""
            alt=""
          >

        </div>
      `;


      document.body.appendChild(
        lightbox
      );

    }


    const lightboxImage =
      lightbox.querySelector(
        '[data-cr-provenance-lightbox-image]'
      );


    const closeButton =
      lightbox.querySelector(
        '[data-cr-provenance-close]'
      );


    if (!lightboxImage) return;



    /* -----------------------------------------
       OPEN LIGHTBOX
       ----------------------------------------- */

    imageButtons.forEach(function (button) {

      /*
       * Prevent duplicate image handlers.
       */

      if (
        button.dataset.crImageReady === 'true'
      ) {
        return;
      }

      button.dataset.crImageReady = 'true';


      button.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          const imageUrl =
            button.getAttribute(
              'data-image'
            );


          if (!imageUrl) return;


          const thumbnail =
            button.querySelector('img');


          lightboxImage.src =
            imageUrl;


          lightboxImage.alt =
            thumbnail
              ? thumbnail.alt
              : '';


          lightbox.classList.add(
            'is-open'
          );


          lightbox.setAttribute(
            'aria-hidden',
            'false'
          );


          document.body.style.overflow =
            'hidden';

        }
      );

    });



    /* -----------------------------------------
       CLOSE LIGHTBOX
       ----------------------------------------- */

    function closeLightbox() {

      lightbox.classList.remove(
        'is-open'
      );


      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );


      document.body.style.overflow =
        '';


      setTimeout(function () {

        lightboxImage.src = '';

      }, 250);

    }


    if (
      closeButton &&
      closeButton.dataset.crCloseReady !== 'true'
    ) {

      closeButton.dataset.crCloseReady =
        'true';


      closeButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          closeLightbox();

        }
      );

    }


    /*
     * Clicking the dark background closes
     * the lightbox.
     */

    if (
      lightbox.dataset.crBackgroundReady !== 'true'
    ) {

      lightbox.dataset.crBackgroundReady =
        'true';


      lightbox.addEventListener(
        'click',
        function (event) {

          if (
            event.target === lightbox
          ) {

            closeLightbox();

          }

        }
      );

    }


    /*
     * Escape closes the lightbox.
     */

    if (
      lightbox.dataset.crKeyboardReady !== 'true'
    ) {

      lightbox.dataset.crKeyboardReady =
        'true';


      document.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key === 'Escape' &&
            lightbox.classList.contains(
              'is-open'
            )
          ) {

            closeLightbox();

          }

        }
      );

    }

  }



  /* =========================================
     INITIAL PAGE LOAD
     ========================================= */

  function initAllProvenance() {

    document
      .querySelectorAll(
        '[data-cr-provenance]'
      )
      .forEach(function (section) {

        initProvenance(section);

      });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllProvenance
    );

  } else {

    initAllProvenance();

  }



  /* =========================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '[data-cr-provenance]'
            )
          : null;


      if (section) {

        initProvenance(section);

      }

    }
  );


})();